import React, { useEffect } from "react";
import { Delete } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useFieldValue } from "components/form/input/NestedField";
import Cliente from "entity/Cliente";
import OkTableFields from "components/OkTable/OkTableField";
import ButtonSelectEntity from "components/ButtonSelectEntity";

export default function PainelClientesPerfil({ uidUser, hideScrollbar }) {
    const [clientes, setClientes] = useFieldValue("clientesPermitidos", []);
    const [clientesRemover, setClientesRemover] = useFieldValue("clientesRemover", []);

    const addItem = (itemAdd) => {
        const itemAddFormated = { uid: itemAdd.uid, nome: itemAdd.nome };
        let newArr = clientes ? clientes.slice() : [];
        let newItem = itemAddFormated;
        newArr.push(newItem);
        setClientes(newArr);
    };

    const removeItem = (index) => {
        let newArr = clientes ? clientes.slice() : [];
        let newArrRe = clientesRemover ? clientesRemover.slice() : [];
        let ag = newArr[index];
        newArrRe.push(ag);
        newArr.splice(index, 1);
        setClientes(newArr);
        setClientesRemover(newArrRe);
    };

    const extraQuery = (col) => {
        col = col.where('status', '==', 'ATIVO');
        return col;
    }

    return (
        <>
            {uidUser ? (
                <Box sx={{ flex: 1, pb: 1 }}>
                    <Box sx={{ display: "flex", p: 1 }}>
                        <Typography variant="h6" sx={{ flex: 1 }}>
                            Clientes Permitidos
                        </Typography>

                        <ButtonSelectEntity
                            buttonText={"Adicionar"}
                            EntityClass={Cliente}
                            extraQuery={extraQuery}
                            onSelect={(selected) => {
                                if (selected) {
                                    console.log("selected", selected);
                                    addItem(selected);
                                }
                            }}
                        />
                    </Box>
                    <OkTableFields
                        name="clientesPermitidos"
                        columns={[
                            {
                                name: "Cliente",
                                field: "nome",
                            },

                            {
                                width: "45px",
                                cell: (t, i) => (
                                    <IconButton onClick={() => removeItem(i)}>
                                        <Delete />
                                    </IconButton>
                                ),
                            },
                        ]}
                        noDataComponent={"Sem Clientes"}
                        hideScrollbar={hideScrollbar}
                    />
                </Box>
            ) : (
                <Typography>Salve o usuário para Adicionar Clientes</Typography>
            )}
        </>
    );
}
